



















import { Component, Vue } from "vue-property-decorator";
import { brand } from "@/config";
import moment from "moment";

@Component
export default class AppFooter extends Vue {
  get year() {
    return moment().format("Y");
  }

  get version() {
    return "0.0.5";
  }

  get date() {
    return "13 June 2023";
  }

  get brandData() {
    return brand;
  }
}
